import { useState } from 'react';
import { ContactInfoConfig } from '@/lib/themeConfig';
import { SaveButton } from './GeneralSection';

interface Props {
  data: ContactInfoConfig;
  onChange: (data: ContactInfoConfig) => void;
}

export default function ContactSection({ data, onChange }: Props) {
  const [local, setLocal] = useState<ContactInfoConfig>(data);
  const [saved, setSaved] = useState(false);

  const update = (key: keyof ContactInfoConfig, value: string) => {
    setLocal(prev => ({ ...prev, [key]: value }));
  };

  const handleSave = () => {
    onChange(local);
    setSaved(true);
    setTimeout(() => setSaved(false), 2000);
  };

  return (
    <div className="max-w-2xl space-y-6">
      <div className="bg-white rounded-2xl p-6 space-y-4">
        <h2 className="text-sm font-semibold text-stone-700 border-b border-stone-100 pb-3">İletişim Bilgileri</h2>

        <div>
          <label className="block text-xs font-medium text-stone-600 mb-1.5">Adres <span className="text-stone-400">(yeni satır için Enter)</span></label>
          <textarea
            value={local.address}
            onChange={e => update('address', e.target.value)}
            rows={2}
            className="w-full px-4 py-2.5 text-sm bg-stone-50 rounded-xl border border-stone-200 focus:border-amber-500 focus:outline-none transition-all resize-none"
          />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label className="block text-xs font-medium text-stone-600 mb-1.5">Telefon</label>
            <input
              type="text"
              value={local.phone}
              onChange={e => update('phone', e.target.value)}
              placeholder="+90 500 123 45 67"
              className="w-full px-4 py-2.5 text-sm bg-stone-50 rounded-xl border border-stone-200 focus:border-amber-500 focus:outline-none transition-all"
            />
          </div>
          <div>
            <label className="block text-xs font-medium text-stone-600 mb-1.5">WhatsApp Numarası <span className="text-stone-400">(90 ile başlayan)</span></label>
            <input
              type="text"
              value={local.whatsapp}
              onChange={e => update('whatsapp', e.target.value)}
              placeholder="905001234567"
              className="w-full px-4 py-2.5 text-sm bg-stone-50 rounded-xl border border-stone-200 focus:border-amber-500 focus:outline-none transition-all"
            />
          </div>
        </div>

        <div>
          <label className="block text-xs font-medium text-stone-600 mb-1.5">E-posta</label>
          <input
            type="text"
            value={local.email}
            onChange={e => update('email', e.target.value)}
            placeholder="merhaba@site.com"
            className="w-full px-4 py-2.5 text-sm bg-stone-50 rounded-xl border border-stone-200 focus:border-amber-500 focus:outline-none transition-all"
          />
        </div>

        <div>
          <label className="block text-xs font-medium text-stone-600 mb-1.5">Çalışma Saatleri</label>
          <textarea
            value={local.working_hours}
            onChange={e => update('working_hours', e.target.value)}
            rows={2}
            className="w-full px-4 py-2.5 text-sm bg-stone-50 rounded-xl border border-stone-200 focus:border-amber-500 focus:outline-none transition-all resize-none"
          />
        </div>
      </div>

      <div className="bg-white rounded-2xl p-6 space-y-4">
        <h2 className="text-sm font-semibold text-stone-700 border-b border-stone-100 pb-3">Harita</h2>
        <div>
          <label className="block text-xs font-medium text-stone-600 mb-1.5">Google Maps Embed URL</label>
          <textarea
            value={local.map_embed_url}
            onChange={e => update('map_embed_url', e.target.value)}
            rows={3}
            placeholder="https://www.google.com/maps/embed?pb=..."
            className="w-full px-4 py-2.5 text-sm bg-stone-50 rounded-xl border border-stone-200 focus:border-amber-500 focus:outline-none transition-all resize-none font-mono text-xs"
          />
          <p className="text-xs text-stone-400 mt-1">Google Maps &gt; Paylaş &gt; Haritayı Göm &gt; HTML kopyala, sadece src="..." kısmını yapıştırın</p>
        </div>
      </div>

      <SaveButton saved={saved} onSave={handleSave} />
    </div>
  );
}
